import { useQuery, useQueryClient } from '@tanstack/react-query';
import { Spin } from 'antd';
import type { CurrentUser } from '@mori/contracts';
import { lazy, Suspense } from 'react';
import { api } from './api';
import { LoginPage } from './pages/LoginPage';

const AuthenticatedApp = lazy(() => import('./AuthenticatedApp').then((module) => ({ default: module.AuthenticatedApp })));

export default function App() {
  const queryClient = useQueryClient(); const { data, isLoading } = useQuery({ queryKey: ['me'], queryFn: () => api<{ user: CurrentUser }>('/auth/me'), retry: false });
  const user = data?.user;
  const setUser = (next?: CurrentUser) => queryClient.setQueryData(['me'], { user: next });
  if (isLoading && !user) return <div className="boot-screen"><Spin size="large"/><span>正在进入墨睿科技EAM系统</span></div>;
  if (!user) return <LoginPage onLogin={(next) => setUser(next)}/>;
  return <Suspense fallback={<div className="boot-screen"><Spin size="large"/><span>正在加载管理工作台</span></div>}><AuthenticatedApp user={user} setUser={setUser}/></Suspense>;
}
